module.exports = __webpack_public_path__ + "static/img/sm_bg.77ad725.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/sm_bg.png
// module id = x0Dh
// module chunks = 1